import Base from './Base';
import Media from '../models/Media';

export default class MediaCollection extends Base {
    get models() {
        const collection = this.data.map(item => new Media(item));
        collection.collection = this;

        return collection;
    }

    get hasAudio() {
        return Boolean(this.models.filter(item => item.isAudio).length);
    }
}
